import api from './api';
import { PublicRide, RidesSortBy } from '../types';

export interface DriverRideFilters {
  search?: string;
  priorities?: string[];
  vehicleTypes?: string[];
  dutyTypes?: string[];
  pickupAreas?: string[];
  dropAreas?: string[];
  sortBy?: RidesSortBy;
  saved?: boolean;
  hidden?: boolean;
  includeHidden?: boolean;
  showSupply?: boolean;
  page?: number;
  limit?: number;
}

const csv = (values?: string[]) => (values && values.length ? values.join(',') : undefined);
const orJoin = (values?: string[]) => (values && values.length ? values.join('|') : undefined);

export const fetchDriverRideById = async (id: string): Promise<PublicRide> => {
  const response = await api.get(`/api/driver/rides/${id}`);
  const ride = response.data.ride;
  return { ...ride, id: ride.id || ride._id };
};

export const fetchDriverRides = async (filters: DriverRideFilters | string = {}) => {
  const f = typeof filters === 'string' ? { search: filters } : filters;
  const params: Record<string, unknown> = {
    page: f.page,
    limit: f.limit ?? 20,
    search: f.search || undefined,
    vehicleTypes: csv(f.vehicleTypes),
    dutyTypes: csv(f.dutyTypes),
    priorities: csv(f.priorities),
    pickupArea: orJoin(f.pickupAreas),
    dropArea: orJoin(f.dropAreas),
    sortBy: f.sortBy && f.sortBy !== 'newest' ? f.sortBy : undefined,
    saved: f.saved || undefined,
    hidden: f.hidden || undefined,
    includeHidden: f.includeHidden || undefined,
    showSupply: f.showSupply || undefined,
  };

  const response = await api.get('/api/driver/rides', { params });
  const rides: PublicRide[] = response.data.rides.map((ride: any) => ({
    ...ride,
    id: ride.id || ride._id,
  }));
  return { rides, pagination: response.data.pagination as { page: number; limit: number; total: number; pages: number } };
};
